export default __webpack_public_path__ + "static/media/youtube-logo.cc706b7a.svg";